export default __webpack_public_path__ + "static/media/bright.3c09f3ca.png";